import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/rentas-dhelos-white.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex items-center bg-darken-green top-0 w-screen h-20 z-30 shadow-lg justify-between fixed"
}
const _hoisted_2 = { class: "flex gap-6 items-center relative px-2 lg:px-12" }
const _hoisted_3 = { class: "flex items-center justify-center lg:hidden" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)
const _hoisted_5 = {
  class: "block h-6 w-6",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "#fff",
  "aria-hidden": "true"
}
const _hoisted_6 = { class: "w-full flex flex-col items-center px-2 pt-10 pb-3 space-y-1 gap-10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "lg:px-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs lg:text-base text-center lg:text-start uppercase text-white" }, " Sistema de Administración "),
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-full mr-5",
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_8 = { class: "flex gap-4 lg:gap-6 items-center px-6" }

import { ref } from "vue";
import { useRouter } from "vue-router";
import { AuthService } from "@/services/auth/AuthService";
import { useAuthStore } from "@/stores/auth";
import AccountMenu from "./AccountMenu.vue";
import NotificationMenu from "./NotificationMenu.vue";
import Modal from "../atoms/Modal.vue";

interface Route {
  name: string;
  label: string;
  param?: Record<string, string | number>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminTopbar',
  setup(__props) {

const routes: Route[] = [
  { name: "params", label: "Parámetros" },
  { name: "investments", label: "Inversiones" },
  { name: "dividends", label: "Dividendos" },
  { name: "shareholders", label: "Accionistas" },
  { name: "users", label: "Usuarios" },
  { name: "message-list", label: "Mensajes" },
];

const router = useRouter();
const authService = new AuthService();
const authStore = useAuthStore();
const isVisibleConfirmationModal = ref<boolean>(false);

const isMenuOpen = ref<boolean>(false);

const user = authStore.user;

async function logout() {
  if (!authStore.token) return;

  const response = await authService.logout(authStore.token);

  if (response.success) {
    router.push({ name: "login" });
    authStore.logout();
  }
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(authStore).token)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "flex items-center justify-center p-2 rounded-md text-white hover:text-light-green focus:outline-none focus:ring-2 focus:ring-inset focus:ring-light-green",
                "aria-expanded": "false",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (isMenuOpen.value = !isMenuOpen.value))
              }, [
                _hoisted_4,
                (_openBlock(), _createElementBlock("svg", _hoisted_5, [
                  _createElementVNode("path", {
                    class: _normalizeClass({ hidden: isMenuOpen.value, 'inline-flex': !isMenuOpen.value }),
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M4 6h16M4 12h16M4 18h16"
                  }, null, 2),
                  _createElementVNode("path", {
                    class: _normalizeClass({ hidden: !isMenuOpen.value, 'inline-flex': isMenuOpen.value }),
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12"
                  }, null, 2)
                ]))
              ]),
              _createElementVNode("div", {
                class: _normalizeClass([{ hidden: !isMenuOpen.value, block: isMenuOpen.value }, "absolute lg:hidden bg-darken-green top-14 right-0 left-0 w-screen h-screen z-40"])
              }, [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(routes, (route, index) => {
                    return _createVNode(_component_router_link, {
                      key: index,
                      to: { name: route.name, params: route.param },
                      class: "text-white hover:text-light-green",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (isMenuOpen.value = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(route.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  }), 64))
                ])
              ], 2)
            ]),
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(routes, (route, index) => {
              return _createVNode(_component_router_link, {
                key: index,
                to: { name: route.name, params: route.param },
                class: "hidden lg:block text-white hover:text-light-green"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(route.label), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(NotificationMenu, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (isMenuOpen.value = false))
            }),
            _createVNode(AccountMenu, {
              user: _unref(user),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (isMenuOpen.value = false))
            }, null, 8, ["user"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(Modal, {
      title: "Confirmación",
      visible: isVisibleConfirmationModal.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (isVisibleConfirmationModal.value = !isVisibleConfirmationModal.value))
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Esta acción cerrará su sesión inmediatamente. ")
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          class: "bg-button-green shadow-md text-white",
          onClick: logout
        }, " Aceptar ")
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})